<template>
  <ValidationProvider :rules="$attrs.rules" v-slot="{ passed, failed }">
    <md-field
      :class="[{ 'md-error': $attrs.rules && failed }, { 'md-valid': $attrs.rules && passed }, { 'md-form-group': $slots['md-icon'] }]"
    >
      <slot name="md-icon"></slot>
      <label :class="$attrs['labelClass']">{{ label }}</label>
      <md-input v-bind:value="value" v-on:change="handleInput" v-bind="$attrs" />

      <slide-y-down-transition>
        <md-icon class="error" v-show="$attrs.rules && failed">close</md-icon>
      </slide-y-down-transition>
      <slide-y-down-transition>
        <md-icon class="success" v-show="$attrs.rules && passed">done</md-icon>
      </slide-y-down-transition>
    </md-field>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { SlideYDownTransition } from 'vue2-transitions'
import { extend } from 'vee-validate'
import { required, numeric, between, email } from 'vee-validate/dist/rules'

extend('required', required)
extend('numeric', numeric)
extend('between', between)
extend('email', email)

export default {
  name: 'BackendText',
  props: ['value', 'label'],
  model: {
    prop: 'value',
    event: 'change',
  },
  components: { SlideYDownTransition, ValidationProvider },
  methods: {
    handleInput(event) {
      this.$emit('change', event.target.value)
    },
  },
}
</script>

<style>
.md-field.md-required label.no-asterisk:after {
  content: '';
}
</style>
